import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OnlineRegistrationIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "OnlineRegistration",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.42 6.11H5.2c-1.77 0-3.19 1.44-3.2 3.21v5.26a3.21 3.21 0 0 0 3.2 3.2h15.71v-1.85H5.2c-.75 0-1.36-.6-1.37-1.35V9.32c0-.76.61-1.38 1.37-1.38h19.22c.76 0 1.37.62 1.37 1.37v2.67l1.82 2.03V9.32c0-1.77-1.43-3.2-3.2-3.21"
      }), /*#__PURE__*/_jsx("path", {
        d: "M29.86 19.32c.04.05.08.11.11.17.09.26-.03.55-.29.65l-2.07.79 1.46 3.82a.49.49 0 0 1-.3.63l-1.26.48c-.26.1-.55-.04-.64-.29l-1.46-3.82-2.07.79c-.06.01-.13.01-.19 0a.49.49 0 0 1-.49-.49v-9.44c0-.15.06-.29.17-.39.21-.18.53-.16.71.05z"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.43 19a1.14 1.14 0 1 1 0-2.28c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14H3.29c-.63 0-1.14.51-1.14 1.14v10.29c0 .63.51 1.14 1.14 1.14h9.14a1.14 1.14 0 1 1 0 2.28H3.29C1.4 19-.14 17.46-.14 15.57V5.29c0-1.89 1.54-3.43 3.43-3.43h25.14c1.89 0 3.43 1.54 3.43 3.43v10.29c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17 11.94v16.2l3.04-5.27c.52-.9 1.57-1.33 2.57-1.07l5.82 1.56L17 11.93Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17 29.29a1.143 1.143 0 0 1-1.15-1.14V11.94c0-.46.28-.88.71-1.06s.92-.08 1.25.25l11.43 11.43c.37.37.44.93.18 1.38s-.79.67-1.29.53l-5.82-1.56c-.5-.13-1.03.09-1.29.53l-3.04 5.27c-.21.36-.59.57-.99.57Zm1.14-14.59v9.17l.91-1.57c.77-1.34 2.36-2 3.86-1.6l1.69.46z"
      })]
    })
  }));
};
OnlineRegistrationIcon.displayName = 'OnlineRegistrationIcon';